export class Expression {
    constructor() {
        this.type = this.constructor.name;
    }
    accept(obj) {
        return true;
    }
    evaluate(visitor, localVariables) {
        throw new Error(`Visitor for '${this.type}' not yet implemented!`);
    }
}
export class SourceBasedExpression extends Expression {
    constructor(source) {
        super();
        this.source = source;
    }
    getSource() {
        return this.source;
    }
}
export class BodyBasedExpression extends SourceBasedExpression {
    setBody(body) {
        this.body = body;
    }
    getBody() {
        return this.body;
    }
    _evaluateBodyAndSource(visitor, localVariables) {
        const source = this.getSource()
            .evaluate(visitor, localVariables);
        const body = this.getBody()
            .evaluate(visitor, localVariables);
        return { source, body };
    }
}
export class IteratorExpression extends BodyBasedExpression {
    setIterators(iterators) {
        this.iterators = iterators;
    }
    getIterators() {
        return this.iterators;
    }
}
//# sourceMappingURL=Expression.js.map